module.exports = __webpack_public_path__ + "img/company_logo.e2ee3933.png";